import React, { useState, useEffect } from 'react';
import SideBar from './SideBar';
import { Outlet } from "react-router-dom";
import '../assets/css/Layout.css';

const Layout = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      // Auto-collapse on mobile
      if (mobile) {
        setIsCollapsed(true);
      }
    };

    // Set initial state
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className={`layout ${isCollapsed ? 'is-collapsed' : ''} ${isMobile ? 'is-mobile' : ''}`}>
      <aside className="sidebar-col">
        <SideBar
          isCollapsed={isCollapsed}
          onToggleCollapse={() => setIsCollapsed(prev => !prev)}
        />
      </aside>

      <main className="content-col">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
